import { useCallback } from 'react'
import { filesApi } from '@papan/files/client'
import { useFileIO, driveFileIO } from '@papan/files/client/file-io'
import { loadFormatConfig } from './project-config.js'
import type { FormatConfig } from './format-config.js'

/**
 * #987 — the loader a text editor hands CodeMirror for the project's formatting
 * settings. Drive only, like the code completions (useAppCodeContext): in a
 * share view the drive API answers as the link, not the person, so there a
 * format uses the defaults.
 */
export function useFormatConfig(fileId: string | undefined, fileName: string | undefined): (() => Promise<FormatConfig>) | undefined {
  const inDrive = useFileIO() === driveFileIO
  const load = useCallback(() => loadFormatConfig(filesApi, fileId!, fileName ?? ''), [fileId, fileName])
  return fileId && inDrive ? load : undefined
}
